import { isEmpty } from "lodash";
import { useCallback } from "react";
import FileUploadField from "../inputs/FileUploadField";
import FileUploadModal from "../modals/common/FileUploadModal";

const FileUploadFieldWithModal = ({
  onClose,
  docGroup,
  docType,
  suppressLabel,
  height,
  suppressUploadButton = true,
  hideUploadIcon = false,
  maxHeight,
  label,
  minHeight,
  onSubmit,
  modalTitle,
  loading,
  //temp test
  inputSx,
  files,
  setFiles,
}) => {
  // const [files, setFiles] = useState(null);

  const handleInitialFileUpload = useCallback(
    (uploadedFiles) => {
      setFiles(uploadedFiles);
    },
    [setFiles],
  );

  return (
    <>
      <FileUploadField
        key={`root-upload-${docType}-initial-upload`}
        keyName={`root-upload-${docType}-initial-file-upload`}
        uploadText={label}
        suppressUploadButton={suppressUploadButton}
        borderSize={1.5}
        minHeight={minHeight}
        docGroup={docGroup}
        docType={docType}
        maxHeight={maxHeight}
        hideUploadIcon={hideUploadIcon}
        suppressLabel={suppressLabel}
        height={height}
        sx={inputSx}
        hideFileList
        onFilesAdded={handleInitialFileUpload}
      />

      {isEmpty(files) ? null : (
        <FileUploadModal
          show={!isEmpty(files)}
          files={files}
          docGroup={docGroup}
          docType={docType}
          title={modalTitle}
          key={`${docType}-${docGroup}-modal-upload`}
          onClose={() => setFiles(null)}
          loading={loading}
          onSubmit={onSubmit}
        />
      )}
    </>
  );
};

export default FileUploadFieldWithModal;
